import { render } from "./left-arrow.svg.vue?vue&type=template&id=e5dbedb6"
import script from "./left-arrow.svg.vue?vue&type=script&lang=js"
export * from "./left-arrow.svg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__